$(() => {
  const cards = document.querySelectorAll("[data-js-progress-cards]")
  const isMobile = window.innerWidth < 1024

  $(document).on("timer:start", () => {
    cards.forEach((card) => {
      const progress = card.querySelectorAll("[data-js-progress]")
      const currentTime = new Date().getTime()
      const itemTimeout = 1000

      let transitionDelay

      progress.forEach((timer, i) => {
        const startTime = new Date(timer.dataset.start).getTime()
        const endTime = new Date(timer.dataset.end).getTime()
        if (
          (i === 0 && currentTime < startTime) ||
          (i === progress.length - 1 && currentTime > endTime)
        ) {
          timer.classList.remove("_hidden", "_preloader")
        } else if (currentTime < endTime && currentTime > startTime) {
          timer.classList.remove("_hidden")
        } else {
          timer.classList.add("_hidden")
        }
        if (currentTime > startTime) {
          const daysLeft = Math.floor((endTime - currentTime) / 1000 / 60 / 60 / 24)
          const daysTotal = Math.floor((endTime - startTime) / 1000 / 60 / 60 / 24)
          let daysPassed = (daysTotal - daysLeft) / daysTotal * 100
          if (daysPassed > 100) daysPassed = 100

          const bar = timer.querySelector("[data-js-progress-bar]")
          timer.classList.remove("_disabled")
          timer.classList.remove("_preloader")
          transitionDelay = isMobile ? 0 : i * itemTimeout

          timer.style.transition = `color ${300}ms ${transitionDelay}ms`
          bar.style.transition = `width ${1000}ms ${transitionDelay}ms`
          bar.style.width = `${daysPassed}%`
        }
      })

      setTimeout(() => {
        $(document).trigger("progress:stop")
      }, transitionDelay + 500)
    })
  })
})



// WEBPACK FOOTER //
// ./src/blocks/progress-cards/progress.js